<template>
    <v-form
        ref="form"
        v-model="valid"
        class="form"
        lazy-validation>
        <v-container class="px-0">
            <div class="d-flex">
                <div
                    v-for="(option, i) of aimOptions"
                    :key="i"
                    class="aim-block-wrapper">
                    <div
                        class="aim-block mb-5"
                        :class="{ 'm-active': i === aim }">
                        <div
                            class="d-flex align-center pa-5"
                            @click="aim = i">
                            <v-icon
                                color="primary"
                                size="48"
                                class="mr-5">
                                {{ option.icon }}
                            </v-icon>

                            <p
                                class="mb-0 text-center"
                                v-html="option.text" />
                        </div>
                    </div>
                    <div
                        class="features-list"
                        :class="{ 'active-features': i === aim }">
                        <h2 class="account-type mb-2 text-center font-weight-regular">
                            {{ option.accountType }}
                        </h2>
                        <ul
                            class="text-left mx-5">
                            <li
                                v-for="(feature, idx) in option.accountFeatures"
                                :key="idx">
                                {{ feature }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <v-row
                justify="center"
                class="mt-5">
                <v-col cols="12">
                    <v-btn
                        color="primary"
                        tile
                        @click="onSubmit">
                        {{ aim === 0 ? 'finish' : 'continue' }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <app-business-info-dialog
            :dialog="businessInfoDialog"
            :sign-up-data="formData"
            @close="businessInfoDialog = false"
            @finish="setBusinessInfo($event)" />
    </v-form>
</template>

<script>
import AppBusinessInfoDialog from '@/components/App/AppBusinessInfoDialog';

export default {
    name: 'SignupForm',
    components: { AppBusinessInfoDialog },
    props: {
        formData: Object,
    },
    data() {
        return {
            valid: true,
            businessInfoDialog: false,
            businessInfo: null,
            aimOptions: [
                {
                    value: 'free',
                    icon: 'mdi-account-outline',
                    text: 'I am a <b>Buyer/Seller</b> who wants to browse',
                    accountType: 'Free Account',
                    accountFeatures: [
                        'Lorem ipsum dolor sit amet',
                        'Consectetur adipisicing elit',
                        'Asperiores cum dolorum eligendi enim',
                    ],
                },
                {
                    value: 'pro',
                    icon: 'mdi-briefcase-outline',
                    text: 'I am an <b>Agent</b> who wants to use a website as a professional',
                    accountType: 'Professional Account',
                    accountFeatures: [
                        'Lorem ipsum dolor sit amet',
                        'Consectetur adipisicing elit',
                        'Asperiores cum dolorum eligendi enim',
                    ],
                },
            ],
            aim: 0,
        };
    },

    methods: {
        async onSubmit() {
            await this.$refs.form.validate();

            if (this.valid) {
                if (this.aim === 0 || this.businessInfoDialog) {
                    this.$emit('finish', {
                        type: this.aimOptions[this.aim].value,
                        businessInfo: this.businessInfo,
                    });

                    this.businessInfoDialog = false;
                } else {
                    this.businessInfoDialog = true;
                }
            }
        },

        setBusinessInfo(ev) {
            this.businessInfo = ev;

            this.onSubmit();
        },
    },
};
</script>

<style scoped lang="scss">
@import 'src/assets/style/variables';

.form {
    padding: 0;
}

.row {
    padding: 0 32px;
}

.aim-block-wrapper {
    width: 50%;
}

.aim-block {
    border: $default-border;
    cursor: pointer;
    text-align: left;
    opacity: 0.7;
    border-bottom: 2px solid #e3e3e3;

    &.m-active {
        border-bottom: 2px solid #000;
        opacity: 1;
    }

    p {
        font-size: 14px;
    }
}

.features-list {
    transition: 0.1s;
    opacity: 0.5;

    &.active-features {
        opacity: 1;
    }
}
</style>